const validate = values => {
	const errors = {};
	if (!values.members || !values.members.length) {
	  errors.members = { _error: 'Debe ingresarse al menos un miembro.' };
	} else {
	  const membersArrayErrors = [];
	  values.members.forEach((member, memberIndex) => {
		const memberErrors = {};
		if (!member || !member.name) {
		  memberErrors.name = 'Este campo es obligatorio';
		  membersArrayErrors[memberIndex] = memberErrors;
		}
		if (!member || !member.cuil) {
		  memberErrors.cuil = 'Este campo es obligatorio';
		  membersArrayErrors[memberIndex] = memberErrors;
		}
		if (member.cuil &&
			(!/(\d{11})$/.test(member.cuil) || !/(2\d{10})$/.test(member.cuil))) {
			memberErrors.cuil = 'El cuil no es válido'
			membersArrayErrors[memberIndex] = memberErrors
		}
	  });
	  if (membersArrayErrors.length) {
		errors.members = membersArrayErrors;
	  }
	}
	return errors;
  };

  export default validate;



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsMembersForm.js
 **/